<template>
  <v-layout row wrap class="payment-container">
    <v-flex xs12>
      <v-tabs
        color="white"
        slider-color="#587e27"
        class="futuristic-tabs"
        grow
      >
        <v-tab ripple key="residency" class="earth-color tab-item">
          <v-icon left small>mdi-account-group</v-icon>
          RESIDENCY CONFIGURATION
        </v-tab>
        <v-tab ripple key="conservation" class="earth-color tab-item">
          <v-icon left small>mdi-cash-multiple</v-icon>
          CONSERVATION FEES
        </v-tab>

        <!-- ============================ RESIDENCY TAB ============================ -->
        <v-tab-item key="residency">
          <v-container fluid grid-list-lg class="tab-panel">
            <v-layout row wrap>
              <!-- FORM -->
              <v-flex xs12 lg4>
                <v-card flat class="futuristic-card form-card">
                  <div class="card-header">
                    <div class="header-left">
                      <v-icon class="header-icon">
                        {{ edit ? 'mdi-pencil' : 'mdi-plus-circle' }}
                      </v-icon>
                      <h4 class="earth-color">
                        {{ edit ? 'EDIT RESIDENCY CATEGORY' : 'ADD RESIDENCY CATEGORY' }}
                      </h4>
                    </div>
                    <div class="title-decoration"></div>
                  </div>

                  <v-card-text class="form-body">
                    <v-form>
                      <v-text-field
                        label="Residency Person"
                        v-model="residency.person"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                        prepend-inner-icon="mdi-account"
                      ></v-text-field>

                      <v-select
                        label="Marker"
                        v-model="residency.marker"
                        :items="['Adult - A', 'Child - C', 'Infant - I']"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        class="futuristic-input"
                        prepend-inner-icon="mdi-tag"
                      ></v-select>

                      <v-select
                        label="Appears in school conservancy fees"
                        v-model="residency.school"
                        :items="['Yes', 'No']"
                        :rules="[(v) => !!v || 'Item is required']"
                        required
                        class="futuristic-input"
                        prepend-inner-icon="mdi-school"
                      ></v-select>

                      <v-text-field
                        label="Max Number"
                        type="number"
                        v-model.number="residency.max_number"
                        :min="0"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                        prepend-inner-icon="mdi-account-multiple"
                      ></v-text-field>

                      <v-text-field
                        label="Income Account Code"
                        v-model="residency.income_account_code"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                        prepend-inner-icon="mdi-cash"
                      ></v-text-field>

                      <v-text-field
                        label="Department Analysis"
                        v-model="residency.department_analysis_code"
                        :rules="requiredRules"
                        required
                        class="futuristic-input"
                        prepend-inner-icon="mdi-chart-tree"
                      ></v-text-field>

                      <v-textarea
                        label="Description"
                        v-model="residency.description"
                        :rules="requiredRules"
                        required
                        type="text"
                        rows="2"
                        class="futuristic-input"
                        prepend-inner-icon="mdi-text"
                      ></v-textarea>

                      <div class="switch-row">
                        <v-switch
                          label="Proof Residency"
                          color="#587e27"
                          v-model="residency.residency_proof"
                          required
                          class="futuristic-switch"
                          hide-details
                        ></v-switch>

                        <v-switch
                          label="Requires Bed Night Levy (BNL)"
                          color="#587e27"
                          v-model="residency.has_bnl"
                          v-if="edit === true"
                          class="futuristic-switch"
                          hide-details
                        ></v-switch>
                      </div>

                      <v-btn
                        block
                        depressed
                        color="primary"
                        type="submit"
                        @click.prevent="postResidencyConf()"
                        v-if="edit === false"
                        class="futuristic-btn primary"
                      >
                        <v-icon left small>mdi-plus</v-icon>
                        Add Residency
                      </v-btn>
                      <v-btn
                        block
                        depressed
                        color="warning"
                        type="submit"
                        @click.prevent="updateResidencyConf()"
                        v-if="edit === true"
                        class="futuristic-btn warning-btn"
                      >
                        <v-icon left small>mdi-content-save</v-icon>
                        Update Residency
                      </v-btn>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-flex>

              <!-- TABLE -->
              <v-flex xs12 lg8>
                <v-card class="futuristic-card table-card">
                  <div class="card-header">
                    <div class="header-left">
                      <v-icon class="header-icon">mdi-format-list-bulleted</v-icon>
                      <h4 class="earth-color">RESIDENCY CATEGORIES</h4>
                    </div>
                    <div class="title-decoration"></div>
                  </div>

                  <v-data-table
                    :headers="residencyColumns"
                    :items="allFullConservationFees"
                    :search="search"
                    :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                    :disable-initial-sort="true"
                    :loading="$loadingTrue"
                    class="futuristic-table"
                  >
                    <v-progress-linear slot="progress" color="#587e27" indeterminate height="3"></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <td class="fancy cell-name">{{ props.item.payment_person }}</td>
                      <td class="fancy">
                        <v-chip small :color="markerColor(props.item.marker)" text-color="white" class="marker-chip">
                          {{ props.item.marker }}
                        </v-chip>
                      </td>
                      <td class="fancy">
                        <v-icon small :color="(props.item.school === 'Y' || props.item.school === 'Yes') ? 'success' : 'grey lighten-1'">
                          {{ (props.item.school === 'Y' || props.item.school === 'Yes') ? 'mdi-check-circle' : 'mdi-minus-circle' }}
                        </v-icon>
                      </td>
                      <td class="fancy mono">{{ props.item.payment_person_income_code }}</td>
                      <td class="fancy mono">{{ props.item.payment_person_dept_code }}</td>
                      <td class="fancy">
                        <v-icon small :color="props.item.residency_proof === 'Yes' ? 'success' : 'grey lighten-1'">
                          {{ props.item.residency_proof === 'Yes' ? 'mdi-shield-check' : 'mdi-shield-off-outline' }}
                        </v-icon>
                      </td>
                      <td class="has-text-right cell-actions">
                        <v-btn
                          small
                          depressed
                          color="warning"
                          @click="editResidency(props.item)"
                          v-if="edit === false"
                          class="futuristic-btn warning-btn action-btn"
                        >
                          <v-icon left small>mdi-pencil</v-icon> Edit
                        </v-btn>
                        <v-btn
                          small
                          depressed
                          color="error"
                          @click="resetInputs2()"
                          v-if="edit === true"
                          class="futuristic-btn error-btn action-btn"
                        >
                          <v-icon left small>mdi-close</v-icon> Cancel
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>

        <!-- ============================ CONSERVATION TAB ============================ -->
        <v-tab-item key="conservation">
          <v-container fluid grid-list-lg class="tab-panel">
            <v-layout row wrap>
              <!-- ADD / EDIT SCHEDULE -->
              <v-flex xs12>
                <v-card flat class="futuristic-card form-card">
                  <div class="card-header">
                    <div class="header-left">
                      <v-icon class="header-icon">
                        {{ (pricedSchedule || pricedConservationSchedule) ? 'mdi-pencil' : 'mdi-calendar-plus' }}
                      </v-icon>
                      <h4 class="earth-color">
                        {{ pricedSchedule ? 'UPDATE PRICING' :
                           pricedConservationSchedule ? 'UPDATE SCHEDULE' :
                           'ADD CONSERVATION FEES' }}
                      </h4>
                    </div>
                    <div class="title-decoration"></div>
                  </div>

                  <v-card-text class="form-body">
                    <!-- EDIT PRICING -->
                    <v-form v-if="pricedSchedule === true">
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <v-autocomplete
                            label="Select Currency"
                            v-model="update_.currency"
                            :items="allCurrencies"
                            :rules="[(v) => !!v || 'Item is required']"
                            required
                            item-text="currency_name"
                            item-value="currency_public_id"
                            :loading="$loadingTrue"
                            class="futuristic-input"
                            prepend-inner-icon="mdi-currency-usd"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            label="Amount"
                            type="number"
                            v-model="update_.amount"
                            :rules="requiredRules"
                            required
                            class="futuristic-input"
                            prepend-inner-icon="mdi-cash"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <div class="form-actions">
                        <v-btn
                          @click.prevent="postEditedPricingSchedule()"
                          depressed
                          color="warning"
                          type="submit"
                          class="futuristic-btn warning-btn"
                        >
                          <v-icon left small>mdi-content-save</v-icon> Update Pricing
                        </v-btn>
                        <v-btn
                          @click.prevent="cancelEditPricedSchedule()"
                          depressed
                          outline
                          class="futuristic-btn outline-btn"
                        >
                          Cancel
                        </v-btn>
                      </div>
                    </v-form>

                    <!-- EDIT SCHEDULE -->
                    <v-form v-if="pricedConservationSchedule === true">
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <v-dialog ref="dialog" persistent v-model="modal1" lazy full-width width="290px" :return-value.sync="scheduleUpdate.start_date">
                            <v-text-field
                              slot="activator"
                              label="Start Date"
                              v-model="scheduleUpdate.start_date"
                              readonly
                              class="futuristic-input"
                              prepend-inner-icon="mdi-calendar-start"
                            ></v-text-field>
                            <v-date-picker v-model="scheduleUpdate.start_date" :min="start_date" scrollable class="futuristic-date-picker">
                              <v-spacer></v-spacer>
                              <v-btn depressed flat color="primary" @click="modal1 = false" class="futuristic-btn">Cancel</v-btn>
                              <v-btn depressed flat color="primary" @click="$refs.dialog.save(scheduleUpdate.start_date)" class="futuristic-btn">OK</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-dialog ref="dialog1" persistent v-model="modal2" lazy full-width width="290px" :return-value.sync="scheduleUpdate.end_date">
                            <v-text-field
                              slot="activator"
                              label="End Date"
                              v-model="scheduleUpdate.end_date"
                              readonly
                              class="futuristic-input"
                              prepend-inner-icon="mdi-calendar-end"
                            ></v-text-field>
                            <v-date-picker v-model="scheduleUpdate.end_date" :min="scheduleUpdate.start_date" scrollable class="futuristic-date-picker">
                              <v-spacer></v-spacer>
                              <v-btn depressed flat color="primary" @click="modal2 = false" class="futuristic-btn">Cancel</v-btn>
                              <v-btn depressed flat color="primary" @click="$refs.dialog1.save(scheduleUpdate.end_date)" class="futuristic-btn">OK</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete
                            label="Select Destination"
                            v-model="scheduleUpdate.destination"
                            :items="allDestinations"
                            item-text="destination_name"
                            item-value="destination_public_id"
                            :loading="$loadingTrue"
                            class="futuristic-input"
                            prepend-inner-icon="mdi-map-marker"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <div class="form-actions">
                        <v-btn
                          @click.prevent="postEditedConservationSchedule()"
                          depressed
                          color="warning"
                          type="submit"
                          class="futuristic-btn warning-btn"
                        >
                          <v-icon left small>mdi-content-save</v-icon> Update Schedule
                        </v-btn>
                        <v-btn
                          @click.prevent="cancelScheduleEdit()"
                          depressed
                          outline
                          class="futuristic-btn outline-btn"
                        >
                          Cancel
                        </v-btn>
                      </div>
                    </v-form>

                    <!-- NEW SCHEDULE -->
                    <v-form v-if="pricedSchedule === false && pricedConservationSchedule === false">
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <v-dialog ref="dialog" persistent v-model="modal1" lazy full-width width="290px" :return-value.sync="conservation_fee.start_date">
                            <v-text-field
                              slot="activator"
                              label="Schedule Start Date"
                              v-model="conservation_fee.start_date"
                              readonly
                              class="futuristic-input"
                              prepend-inner-icon="mdi-calendar-start"
                            ></v-text-field>
                            <v-date-picker v-model="conservation_fee.start_date" :min="start_date" scrollable class="futuristic-date-picker">
                              <v-spacer></v-spacer>
                              <v-btn depressed flat color="primary" @click="modal1 = false" class="futuristic-btn">Cancel</v-btn>
                              <v-btn depressed flat color="primary" @click="$refs.dialog.save(conservation_fee.start_date)" class="futuristic-btn">OK</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-dialog ref="dialog1" persistent v-model="modal2" lazy full-width width="290px" :return-value.sync="conservation_fee.end_date">
                            <v-text-field
                              slot="activator"
                              label="Schedule End Date"
                              v-model="conservation_fee.end_date"
                              readonly
                              class="futuristic-input"
                              prepend-inner-icon="mdi-calendar-end"
                            ></v-text-field>
                            <v-date-picker v-model="conservation_fee.end_date" :min="conservation_fee.start_date" scrollable class="futuristic-date-picker">
                              <v-spacer></v-spacer>
                              <v-btn depressed flat color="primary" @click="modal2 = false" class="futuristic-btn">Cancel</v-btn>
                              <v-btn depressed flat color="primary" @click="$refs.dialog1.save(conservation_fee.end_date)" class="futuristic-btn">OK</v-btn>
                            </v-date-picker>
                          </v-dialog>
                        </v-flex>
                        <v-flex xs12>
                          <v-autocomplete
                            label="Select Destination (Not Mandatory)"
                            v-model="conservation_fee.destination_details"
                            :items="allDestinations"
                            item-text="destination_name"
                            item-value="destination_public_id"
                            :return-object="true"
                            :loading="$loadingTrue"
                            class="futuristic-input"
                            prepend-inner-icon="mdi-map-marker"
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>

                      <!-- Fees matrix -->
                      <div class="matrix-header">
                        <v-icon small class="mr-1">mdi-table</v-icon>
                        FEE MATRIX
                        <span class="matrix-count">{{ new_schedule_rows.length }} categories</span>
                      </div>
                      <div class="matrix-wrap">
                        <table class="matrix-table">
                          <thead>
                            <tr>
                              <th style="width: 30%;">Category</th>
                              <th style="width: 22%;">Currency</th>
                              <th style="width: 24%;">Conservation</th>
                              <th style="width: 24%;">BNL</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, idx) in new_schedule_rows" :key="idx">
                              <td class="matrix-cat">{{ row.person_details }}</td>
                              <td>
                                <v-autocomplete
                                  v-model="row.currency"
                                  :items="allCurrencies"
                                  item-text="currency_name"
                                  item-value="currency_public_id"
                                  dense hide-details
                                  class="futuristic-input matrix-input"
                                ></v-autocomplete>
                              </td>
                              <td>
                                <v-text-field
                                  v-model.number="row.conservation_amount"
                                  type="number" min="0"
                                  dense hide-details
                                  class="futuristic-input matrix-input"
                                ></v-text-field>
                              </td>
                              <td>
                                <v-text-field
                                  v-model.number="row.bnl_amount"
                                  type="number" min="0"
                                  dense hide-details
                                  class="futuristic-input matrix-input"
                                ></v-text-field>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <div class="form-actions">
                        <v-btn
                          depressed
                          block
                          color="primary"
                          type="submit"
                          @click.prevent="postConservationFee()"
                          class="futuristic-btn primary"
                        >
                          <v-icon left small>mdi-calendar-check</v-icon> Post Schedule
                        </v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-flex>

              <!-- SCHEDULE TABLE -->
              <v-flex xs12>
                <v-card class="futuristic-card table-card">
                  <div class="card-header">
                    <div class="header-left">
                      <v-icon class="header-icon">mdi-calendar-range</v-icon>
                      <h4 class="earth-color">CONSERVATION FEES</h4>
                    </div>
                    <div class="title-decoration"></div>
                  </div>

                  <v-data-table
                    :headers="columns"
                    :items="allFullConservationSchedule"
                    :search="search"
                    :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                    :disable-initial-sort="true"
                    :loading="$loadingTrue"
                    class="futuristic-table"
                  >
                    <v-progress-linear slot="progress" color="#587e27" indeterminate height="3"></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <!-- Duration & Destination Cells -->
                      <td class="fancy cell-date" style="vertical-align: top; padding-top: 16px;">
                        <v-icon small color="#587e27" class="mr-1">mdi-calendar</v-icon>
                        {{ formated_date(props.item.schedule_start_date) }} — {{ formated_date(props.item.schedule_end_date) }}
                      </td>
                      <td class="fancy" style="vertical-align: top; padding-top: 16px;">
                        <v-icon small color="grey" class="mr-1">mdi-map-marker</v-icon>
                        {{ props.item.schedule_destination }}
                      </td>
                      
                      <!-- FEE CHIPS CELL (Fixed structure) -->
                      <td style="padding: 12px;">
                        <div class="fees-chips-container">
                          <span
                            v-for="(fee, i) in props.item.fees"
                            :key="i"
                            class="fee-chip"
                          >
                            <span class="fee-amount">{{ fee.payment_currency }} {{ fee.payment_price }}</span>
                            <span class="fee-person">{{ fee.payment_person }}</span>
                            <v-btn
                              icon small
                              color="warning"
                              @click="editPricedSchedule(fee)"
                              v-if="pricedSchedule === false"
                              class="fee-edit-btn"
                            >
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                              icon small
                              color="error"
                              @click="cancelEditPricedSchedule()"
                              v-if="pricedSchedule === true"
                              class="fee-edit-btn"
                            >
                              <v-icon small>mdi-close</v-icon>
                            </v-btn>
                          </span>
                        </div>
                      </td>

                      <!-- Actions Cell -->
                      <td class="has-text-right cell-actions" style="vertical-align: top; padding-top: 16px;">
                        <v-btn
                          small depressed color="warning"
                          @click="editConservationSchedule(props.item)"
                          v-if="pricedConservationSchedule === false"
                          class="futuristic-btn warning-btn action-btn"
                        >
                          <v-icon left small>mdi-pencil</v-icon> Edit
                        </v-btn>
                        <v-btn
                          small depressed color="error"
                          @click="deleteConservationSchedule(props.item)"
                          v-if="pricedConservationSchedule === false"
                          class="futuristic-btn error-btn action-btn"
                        >
                          <v-icon left small>mdi-eye-off</v-icon> Disable
                        </v-btn>
                        <v-btn
                          small depressed color="error"
                          @click="cancelScheduleEdit()"
                          v-if="pricedConservationSchedule === true"
                          class="futuristic-btn error-btn action-btn"
                        >
                          <v-icon left small>mdi-close</v-icon> Cancel
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "conservancy-fees",
  data() {
    return {
      localSchedule: localStorage.getItem("localSchedule"),
      start_date: this.$moment().format("YYYY-MM-DD"),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      pricedSchedule: false,
      pricedConservationSchedule: false,
      requiredRules: [(v) => !!v || "This field is required"],
      search: "",
      edit: false,
      columns: [
        { text: "Schedule Duration", value: "" },
        { text: "Schedule Destination", value: "schedule_destination" },
        { text: "" },
        { text: "Action" },
      ],
      localScheduleColumns: [
        { text: "Amount", value: "payment_currency" },
        { text: "Residency", value: "payment_person" },
      ],
      scheduleColumns: [
        { text: "Amount", value: "payment_currency" },
        { text: "Residency", value: "payment_person" },
        { text: "Action", value: "" },
      ],
      residencyColumns: [
        { text: "Name", value: "" },
        { text: "Marker", value: "" },
        { text: "Appears In School", value: "" },
        { text: "Income Account Code", value: "" },
        { text: "Department Analysis Code", value: "" },
        { text: "Needs Proof?", value: "" },
        { text: "Action", value: "" },
      ],
      conservation_fee: {
        start_date: "",
        end_date: "",
        fees: [],
        destination: "",
        destination_details: {},
        session_id: localStorage.getItem("lkjhgfdsa"),
      },
      residency: {
        payment_id: "",
        person: "",
        description: "",
        marker: "",
        school: "",
        max_number: "",
        income_account_code: "",
        department_analysis_code: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
        residency_proof: false,
        has_bnl: false,
      },
      update_: {
        price_id: "",
        amount: 0,
        currency: "",
      },
      scheduleUpdate: {
        schedule_id: "",
        start_date: "",
        end_date: "",
        destination: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
      },
      new_schedule_rows: [],
    };
  },
  created() {
    this.$store.dispatch("get_full_conservation_fees");
    this.$store.dispatch("get_all_currencies");
    this.$store.dispatch("get_all_destinations");
    this.$store.dispatch("get_all_conservation_schedule");
    this.buildNewScheduleRows();
  },
  methods: {
    buildNewScheduleRows: function () {
      const fees = this.$store.state.ConservationFeeStore.all_full_conservation_fees || [];
      const conservationFees = fees
        .filter((f) => !f.payment_person.toLowerCase().endsWith(" bnl"))
        .sort((a, b) => a.payment_person.localeCompare(b.payment_person));
      this.new_schedule_rows = conservationFees.map((f) => ({
        payment_person: f.payment_public_id,
        person_details: f.payment_person,
        currency: null,
        conservation_amount: 0,
        bnl_amount: 0,
      }));
    },
    resetSchedule: function () {
      this.conservation_fee = {
        start_date: "",
        end_date: "",
        fees: [],
        destination: "",
        destination_details: {},
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
    },
    postConservationFee: function () {
      const fees = this.new_schedule_rows.map((row) => ({
        payment_person: row.payment_person,
        person_details: row.person_details,
        currency: row.currency,
        conservation_amount: row.conservation_amount,
        bnl_amount: row.bnl_amount,
      }));

      const payload = {
        start_date: this.conservation_fee.start_date,
        end_date: this.conservation_fee.end_date,
        destination_details: this.conservation_fee.destination_details,
        session_id: this.conservation_fee.session_id,
        fees: fees,
      };

      var instance = this;
      this.$store
        .dispatch("post_conservation_fee_schedule", payload)
        .then(function () {
          instance.resetSchedule();
          instance.buildNewScheduleRows();
          instance.$store.dispatch("get_all_conservation_schedule");
        });
    },
    postResidencyConf: function () {
      var instance = this;
      this.$store.dispatch("post_conservation_fee", this.residency).then(function () {
        instance.cancelEdit();
      });
    },
    updateResidencyConf: function () {
      var instance = this;
      this.$store.dispatch("update_conservation_fee", this.residency).then(function () {
        instance.cancelEdit();
      });
      this.edit = false;
    },
    editResidency: function (residency_) {
      this.residency.payment_id = residency_.payment_public_id;
      this.residency.person = residency_.payment_person;
      this.residency.description = residency_.description;
      this.residency.department_analysis_code = residency_.payment_person_dept_code;
      this.residency.income_account_code = residency_.payment_person_income_code;
      
      if (residency_.marker === "A" || residency_.marker === "Adult - A") {
        this.residency.marker = "Adult - A";
      } else if (residency_.marker === "C" || residency_.marker === "Child - C") {
        this.residency.marker = "Child - C";
      } else if (residency_.marker === "I" || residency_.marker === "Infant - I") {
        this.residency.marker = "Infant - I";
      }
      
      if (residency_.school === "Y") {
        this.residency.school = "Yes";
      } else if (residency_.school === "N") {
        this.residency.school = "No";
      }
      
      if (residency_.residency_proof === "Yes") {
        this.residency.residency_proof = true;
      } else {
        this.residency.residency_proof = false;
      }
      
      this.residency.max_number = residency_.max_number;

      const hasTwin = this.$store.state.ConservationFeeStore.all_full_conservation_fees.some(
        f => f.payment_person.toLowerCase() === (residency_.payment_person + " BNL").toLowerCase()
      );
      this.residency.has_bnl = hasTwin || false;

      this.edit = true;
    },
    editPricedSchedule: function (pricing) {
      this.update_.price_id = pricing.price_public_id;
      this.update_.amount = pricing.payment_price;
      this.update_.currency = pricing.payment_currency_id;
      this.pricedSchedule = true;
    },
    postEditedPricingSchedule: function () {
      var data = {
        price_id: this.update_.price_id,
        currency: this.update_.currency,
        amount: this.update_.amount,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("edit_conservation_schedule_pricing", data);
      this.pricedSchedule = false;
    },
    cancelEditPricedSchedule: function () {
      this.pricedSchedule = false;
    },
    deleteConservationFee: function (publicId) {
      var data = {
        payment_id: publicId,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("delete_conservation_fee", data);
    },
    editConservationSchedule: function (schedule) {
      this.pricedConservationSchedule = true;
      this.scheduleUpdate.schedule_id = schedule.schedule_public_id;
      this.scheduleUpdate.destination = schedule.schedule_destination_id;
    },
    postEditedConservationSchedule: function () {
      var data = {
        schedule_id: this.scheduleUpdate.schedule_id,
        start_date: this.scheduleUpdate.start_date,
        end_date: this.scheduleUpdate.end_date,
        session_id: localStorage.getItem("lkjhgfdsa"),
        destination: this.scheduleUpdate.destination,
      };
      this.$store.dispatch("edit_conservation_schedule", data);
      this.pricedConservationSchedule = false;
    },
    deleteConservationSchedule: function (schedule) {
      var data = {
        schedule_id: schedule.schedule_public_id,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("delete_conservation_schedule", data);
    },
    cancelScheduleEdit: function () {
      this.pricedConservationSchedule = false;
    },
    resetInputs2: function () {
      this.edit = false;
      this.residency.person = "";
      this.residency.marker = "";
      this.residency.max_number = "";
      this.residency.description = "";
      this.residency.school = "";
      this.residency.income_account_code = "";
      this.residency.department_analysis_code = "";
      this.residency.has_bnl = false;
    },
    // UI-only helper for chip coloring
    markerColor(marker) {
      if (marker === "A" || marker === "Adult - A") return "#3b82f6";
      if (marker === "C" || marker === "Child - C") return "#f59e0b";
      if (marker === "I" || marker === "Infant - I") return "#8b5cf6";
      return "#9ca3af";
    },
  },
};
</script>

<style scoped>
/* ==================== Container ==================== */
.payment-container {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}
.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
}

/* ==================== Tabs ==================== */
.futuristic-tabs >>> .v-tabs__bar {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  border-radius: 12px;
  padding: 6px;
}
.futuristic-tabs >>> .v-tabs__item {
  font-weight: 600;
  text-transform: none;
  transition: all 0.2s ease;
  border-radius: 8px;
  margin: 0 4px;
  letter-spacing: 0.5px;
}
.futuristic-tabs >>> .v-tabs__item:hover {
  background: #f0f4f8;
}
.futuristic-tabs >>> .v-tabs__item--active {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.tab-item {
  font-size: 13px !important;
  min-width: 220px;
}
.tab-panel {
  padding: 20px 4px 4px;
}

/* ==================== Cards ==================== */
.futuristic-card {
  border-radius: 12px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
}
.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08) !important;
}
.form-card,
.table-card {
  height: 100%;
}

/* ==================== Card header ==================== */
.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px 20px;
  margin-bottom: 0;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.header-icon {
  color: #587e27 !important;
}
.earth-color {
  color: #587e27;
  font-weight: 700;
  margin: 0;
  font-size: 15px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}
.title-decoration {
  height: 3px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-top: 12px;
  width: 80px;
  border-radius: 2px;
}
.form-body {
  padding: 20px;
}

/* ==================== Inputs ==================== */
.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  transition: all 0.2s ease;
  min-height: 40px;
}
.futuristic-input >>> .v-input__slot:hover {
  background: #eef1f6;
}
.futuristic-input >>> .v-input__slot:focus-within {
  background: #ffffff;
  box-shadow: 0 0 0 2px rgba(88, 126, 39, 0.15);
}
.futuristic-input >>> .v-input__prepend-inner .v-icon {
  color: #8a9a7b;
}
.matrix-input >>> .v-input__slot {
  min-height: 36px !important;
  background: #ffffff;
  border: 1px solid #e8eaf6;
}

/* ==================== Switches ==================== */
.switch-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0 12px;
}
.futuristic-switch >>> .v-input--switch__track {
  background: #d1dbc5;
}
.futuristic-switch >>> .v-input--switch__thumb {
  background: #587e27;
}
.futuristic-switch >>> .v-label {
  font-size: 13px;
  color: #4a5568;
}

/* ==================== Buttons ==================== */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  color: white !important;
  box-shadow: none !important;
}
.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12) !important;
}
.futuristic-btn.primary {
  background: linear-gradient(45deg, #587e27, #4caf50) !important;
}
.warning-btn {
  background: linear-gradient(45deg, #f59e0b, #fbbf24) !important;
}
.error-btn {
  background: linear-gradient(45deg, #e53935, #d81b60) !important;
}
.outline-btn {
  color: #587e27 !important;
  border: 1px solid #587e27 !important;
  background: transparent !important;
  box-shadow: none !important;
}
.action-btn {
  margin: 2px 0;
  font-size: 12px !important;
  min-width: auto !important;
  height: 30px !important;
}
.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 16px;
  flex-wrap: wrap;
}
.form-actions .futuristic-btn {
  flex: 1;
}

/* ==================== Tables ==================== */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  white-space: nowrap;
  border-bottom: 2px solid #d1dbc5 !important;
}
.futuristic-table >>> tbody tr {
  transition: background 0.15s ease;
}
.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #fafbfd;
}
.futuristic-table >>> tbody tr:hover {
  background-color: #f0f7e8 !important;
}
.futuristic-table >>> tbody td {
  font-size: 13px;
  vertical-align: middle;
}
.cell-name {
  font-weight: 600;
  color: #2d3748;
}
.cell-actions {
  white-space: nowrap;
}
.mono {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: #5e6e4e;
}
.marker-chip {
  height: 22px !important;
  font-size: 11px !important;
  font-weight: 600 !important;
  min-width: 32px;
  justify-content: center;
}

/* ==================== Fee chips (Fixed layout) ==================== */
.fees-chips-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 140px;
  overflow-y: auto;
  padding-right: 6px;
}
.fees-chips-container::-webkit-scrollbar {
  width: 5px;
}
.fees-chips-container::-webkit-scrollbar-track {
  background: transparent;
}
.fees-chips-container::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 4px;
}

.fee-chip {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 12px;
  transition: all 0.15s ease;
  width: 100%;
}
.fee-chip:hover {
  background: #eef1f6;
  border-color: #cbd5e0;
}
.fee-amount {
  font-weight: 700;
  color: #587e27;
  min-width: 80px;
}
.fee-person {
  color: #4a5568;
  font-size: 12px;
  flex-grow: 1;
}
.fee-edit-btn {
  width: 24px !important;
  height: 24px !important;
  margin: 0 !important;
}

/* ==================== Fee matrix (new schedule) ==================== */
.matrix-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 20px 0 10px;
  font-weight: 700;
  font-size: 12px;
  color: #587e27;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}
.matrix-count {
  margin-left: auto;
  font-weight: 500;
  font-size: 11px;
  color: #718096;
  text-transform: none;
  letter-spacing: 0;
}
.matrix-wrap {
  border: 1px solid #e8eaf6;
  border-radius: 10px;
  overflow: hidden;
}
.matrix-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
.matrix-table thead th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 700;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  padding: 10px;
  text-align: left;
  border-bottom: 2px solid #d1dbc5;
}
.matrix-table tbody tr {
  border-bottom: 1px solid #eef1f6;
}
.matrix-table tbody tr:last-child {
  border-bottom: none;
}
.matrix-table tbody tr:nth-of-type(even) {
  background: #fafbfd;
}
.matrix-table tbody td {
  padding: 8px 10px;
  vertical-align: middle;
}
.matrix-cat {
  font-weight: 600;
  font-size: 13px;
  color: #2d3748;
}

/* ==================== Date pickers ==================== */
.futuristic-date-picker >>> .v-picker__title {
  background: linear-gradient(45deg, #587e27, #4caf50);
  color: white;
}
.futuristic-date-picker >>> .v-date-picker-table th {
  color: #587e27;
}

/* ==================== Responsive ==================== */
@media (max-width: 1264px) {
  .form-card,
  .table-card {
    height: auto;
  }
}
@media (max-width: 960px) {
  .payment-container { padding: 12px; }
  .card-header { padding: 12px 16px; }
  .earth-color { font-size: 13px; }
  .tab-item { font-size: 12px !important; min-width: 0; }
  .tab-panel { padding: 12px 0 0; }
  .form-body { padding: 16px; }
  .form-actions { flex-direction: column; }
  .form-actions .futuristic-btn { width: 100%; }
}
@media (max-width: 600px) {
  .payment-container { padding: 8px; border-radius: 8px; }
  .card-header { padding: 10px 12px; }
  .earth-color { font-size: 12px; letter-spacing: 0.4px; }
  .form-body { padding: 12px; }
  .matrix-table tbody td { padding: 6px; }
  .matrix-table thead th { padding: 8px 6px; font-size: 10px; }
  .matrix-cat { font-size: 12px; }
  .fee-chip { padding: 2px 2px 2px 8px; font-size: 11px; }
}
</style>